// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";

export const signPOA = async ({
  phoneNumber,
  email,
  personalNumber,
  transactionId,
  validFrom,
  validTo,
  name,
  credentials,
  signText,
}: {
  phoneNumber: string;
  email: string;
  personalNumber: string;
  transactionId: string;
  validFrom: string;
  validTo: string | null;
  name: string;
  credentials: unknown;
  signText: unknown;
}) => {
  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/auth/sign`,
    credentials,
    { "content-type": "application/json" },
    {
      phoneNumber,
      email,
      personalNumber,
      transactionId,
      validFrom,
      validTo,
      name,
      signText,
    }
  );

  const response = await apiClient({
    url: `/auth/sign`,
    method: "POST",
    headers: signedRequest?.options?.headers,
    data: signedRequest.options.body,
  });

  return response.data;
};

export const useSignPOA = () =>
  useMutation({
    mutationFn: ({
      phoneNumber,
      email,
      personalNumber,
      transactionId,
      validFrom,
      validTo,
      name,
      credentials,
      signText,
    }: {
      phoneNumber: string;
      email: string;
      personalNumber: string;
      transactionId: string;
      validFrom: string;
      validTo: string | null;
      name: string;
      credentials: unknown;
      signText: string;
    }) =>
      signPOA({
        phoneNumber,
        email,
        personalNumber,
        transactionId,
        validFrom,
        validTo,
        name,
        credentials,
        signText,
      }),
  });
